import { render, staticRenderFns } from "./patch_register_dialog.vue?vue&type=template&id=2c37ae55"
import script from "./patch_register_dialog.vue?vue&type=script&lang=js"
export * from "./patch_register_dialog.vue?vue&type=script&lang=js"
import style0 from "./patch_register_dialog.vue?vue&type=style&index=0&id=2c37ae55&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports